<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="500">
            <v-card
                flat>
                <v-card-title>{{ title }}</v-card-title>
                 <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-form
                        v-model="valid"
                        ref="form">
                        <v-text-field
                            :label="$t('dimension')"
                            v-model="form.name"
                            :rules="rules.name">
                        </v-text-field>
                         <v-text-field
                            :label="$t('number')"
                            v-model="form.number">
                        </v-text-field>
                        <auto-complete-search
                            v-model="form.parent_id"
                            :loading="loading.dimension"
                            :items="dimensions"
                            :idItem="form.parent_id"
                            :search-input.sync="search"
                            @update:search-input="fetchDimensionsData"
                            :label="$t('dimension_group')"
                            :error="field.dimension.error"
                            @resetError="clearDimensionMessage"
                            :error-message="field.dimension.message">
                        </auto-complete-search>
                        <v-select
                            :label="$t('dimension_type')"
                            :items="dimensionTypes"
                            v-model="form.type_id"
                            item-text="name"
                            item-value="id">
                        </v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="submit" :disabled="!valid" :loading="loading.submit" text>{{ $t('save_btn') }}</v-btn>
                    <v-btn @click="close" text>{{ $t('close_btn') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <DimensionDialog
            v-if="dimensionDialogProps.display"
            :id="dimensionDialogProps.id"
            @close="closeDimensionDialog"
            @submit="createdDataFetch"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
import { mapActions, mapState } from 'vuex';
import AutoCompleteSearch from '../common/AutoCompleteSearch.vue';
import { getIdempotentKey } from './../../services/ledger'
export default {
    name: "DimensionDialog",
    components: {
        RetryDialog,
        AutoCompleteSearch
    },
    props: {
        id: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            display: true,
            valid: false,
            openParams: null,
            search:'',
            // dimensions: [],
            mode: {
                edit: false
            },
            idempotentKey: null,
            form: {
                id: null,
                name: null,
                number: null,
                parent_id: null,
                type_id: null
            },
            rules: {
                name: [
                    v => !!v || this.$t('rules_required'),
                ],
                parent_id: [
                    v => !!v || this.$t('rules_required'),
                ]
            },
            field: {
                dimension: {
                    message: '',
                    error: false
                }
            },
            loading: {
                data: false,
                submit: false,
                dimension: false
            },
            dimensionDialogProps: {
                id: null,
                display: false
            },
        }
    },
    computed: {
        ...mapState('accounting/dimension', ["dimension", "dimensions"]),
        ...mapState('accounting/dimensionType', ["dimensionTypes"]),
        editMode() {
            return !this.notEditMode;
        },
        notEditMode() {
            return !this.id;
        },
        title() {
            if(this.notEditMode) return this.$t('new_dimension');
            else return this.$t('edit_dimension');
        },
        ser() {
            return this.search;
        }
    },
    methods: {
        ...mapActions('accounting/dimension', ["fetchDimensions","fetchDimension", "storeDimension", "updateDimension"]),
        ...mapActions('accounting/dimensionType', ["fetchDimensionTypes"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        async createdDataFetch() {
            try {
                this.loading.data = true;
                if(this.editMode) {
                    await this.fetchDimension(this.id);
                    this.form =  this._.clone(this.dimension);
                    this.search = this.dimension.parent;
                    await this.fetchDimensionsData();
                }
                await this.fetchDimensionTypes();
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },
        async fetchDimensionsData() {
            this.loading.dimension = true;
            this.clearDimensionMessage();
            let result = await this.fetchDimensions({ parent_id: 1, search: this.search});
            if(result.data.length == 0) this.setDimensionMessage("Your search didn't match any record!")
            this.loading.dimension = false;
        },
        setDimensionMessage(val) {
            this.field.dimension.message = val;
            this.field.dimension.error = true;
        },
        clearDimensionMessage() {
            this.field.dimension.message = '';
            this.field.dimension.error = false;
        },
        submit() {
            this.loading.submit = true;
            if(this.notEditMode) {
                this.form.idempotentKey = this.idempotentKey;
                this.storeDimension(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.setSnackBars({color: "success", message: this.$t("record_save_success")});
                    }).catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error.message;
                        this.setSnackBars({color: "error", message});
                    })
            } else {
                this.updateDimension(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.setSnackBars({color: "success", message: this.$t("record_update_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({color: "error", message});
                    })
            }

        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
        close() {
           this.$emit('close');
        },
        fetchIdempotentKey() {
            getIdempotentKey()
                .then(response => {
                    this.idempotentKey = response.data.key;
                })
        }
    },
    created () {
        this.createdDataFetch();
        this.fetchIdempotentKey();
    },
    updated() {
        this.$on('update:list-index', (val) => {
            console.log('val', val);
        })
    }
}
</script>